import "../Styles/app.scss";

// Angular
import type { IModule } from "angular";
import { module } from "angular";

// External angular directives, services, etc.
import "angular-animate";
import "angular-aria";
import "angular-breadcrumb";
import "angular-ui-bootstrap";
import "@uirouter/angularjs";
import "angular-translate";
import "angular-simple-logger";
import "angular-google-maps";
import "ng-file-upload";
import "ngSmoothScroll";
import "@progress/kendo-ui/js/kendo.angular";

import "ev-emitter";
import "desandro-matches-selector";
import "fizzy-ui-utils";
import "get-size";
import "outlayer";
import jQueryBridget from "jquery-bridget";
import Masonry from "masonry-layout";
import imagesLoaded from "imagesloaded";
import "angular-masonry";

import jq from "jquery";
import appConfig from "./AppConfig";
import appRun from "./AppRun";

// tslint:enable:ordered-imports
jQueryBridget("masonry", Masonry, jq);
(imagesLoaded as any).makeJQueryPlugin(jq);

export const app: IModule = module("mmManagePortal", [
    "ngAnimate",
    "ngAria",
    "ui.router",
    "pascalprecht.translate",
    "ncy-angular-breadcrumb",
    "kendo.directives",
    "nemLogging",
    "uiGmapgoogle-maps",
    "ngFileUpload",
    "smoothScroll",
    "irReact",
    "irUtils",
    "mmAuth",
    "mmServices",
    "mmHttpInterceptors",
    "mmRepositories",
    "mmGui",
    "mmGlobalisation",
    "wu.masonry",
])
    .config(appConfig)
    .run(appRun);
